import React from 'react'
import { AiOutlineMail } from 'react-icons/ai'
import { bhEnv } from '@lib/env'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa'

interface BHSocialsProps {
  size: number
  className?: string
}
function BHSocials({ size, className }: BHSocialsProps) {
  return (
    <div className={`flex gap-4  ${className ? className : ''}`}>
      <a href={bhEnv.companyInfo.facebook}>
        <FaFacebookF size={size} />
      </a>
      <a href={bhEnv.companyInfo.linkedin}>
        <FaLinkedinIn size={size} />
      </a>
      <a href={`mailto:${bhEnv.companyInfo.email}`}>
        <AiOutlineMail size={size} />
      </a>
    </div>
  )
}

export default BHSocials
